import { useAgentTelemetry } from '../hooks/useAgentTelemetry';

export default function AgentStatusRibbon({ sessionId }: { sessionId: string }) {
    const evt = useAgentTelemetry(sessionId);

    if (!evt) return null;

    const chipColor =
        evt.state === 'COMPLETE'
            ? 'bg-emerald-600'
            : evt.state === 'ERROR'
              ? 'bg-rose-600'
              : evt.state === 'WAITING'
                ? 'bg-amber-600'
                : 'bg-sky-600';

    const stepTxt = evt.step
        ? `Step ${evt.step.idx}/${evt.step.total}: ${evt.step.title}`
        : evt.msg;

    return (
        <div className="w-full flex items-center justify-between gap-3 px-3 py-2 rounded-md bg-zinc-900/60 border border-zinc-800">
            <div className={`text-xs font-semibold px-2 py-1 rounded ${chipColor}`}>
                {evt.state}
            </div>
            <div className="text-sm truncate">{stepTxt}</div>
            <div className="text-xs opacity-70">
                {evt.metrics?.elapsedMs ? `⏱ ${(evt.metrics.elapsedMs / 1000).toFixed(1)}s` : null}
            </div>
        </div>
    );
}
